import { coerceBooleanProperty } from '@angular/cdk/coercion';
import {
  AfterContentInit,
  ChangeDetectorRef,
  Component,
  Directive,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
  input,
  output,
  contentChild,
  contentChildren,
  model,
  effect,
  signal,
} from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import {
  GrowInAnimation,
  GrowOutAnimation,
} from '../../animations/grow.animation';
import { ColorComponentMixinBase } from '../../common-behavior/color';
import { MatIcon } from '@angular/material/icon';

@Directive({
  selector: '[slot="closed-view"]',
  standalone: true,
})
export class ContextFrameClosedViewDirective {}

@Component({
  selector: 'mulo-context-frame',
  templateUrl: './context-frame.component.html',
  styleUrls: ['./context-frame.component.scss'],
  animations: [GrowInAnimation, GrowOutAnimation],
  host: {
    '(keydown.escape)': 'closeFrame($event)',
    '[class.is-active]': 'isOpen()',
    '[class.is-visible]': 'visibleClass()',
    '[class.hasnt-open-btn]': '!showOpenBtn()',
  },
  inputs: ['color'],
  imports: [MatIconButton, MatIcon, MatButton],
})
export class ContextFrameComponent
  extends ColorComponentMixinBase
  implements AfterContentInit
{
  readonly isOpen = model(false);

  readonly open = output();
  readonly close = output();

  readonly btnIcon = input('plus');
  readonly rtlMirrorIcon = input<boolean>(undefined);
  readonly btnLabel = input('Add');
  readonly showOpenBtn = input(true);
  readonly closeBtnAriaLabel = input('Close');

  readonly visibleClass = signal(false);

  readonly closedView = contentChild(ContextFrameClosedViewDirective);
  readonly buttons = contentChildren(MatButton, { descendants: true });

  constructor() {
    const elementRef = inject(ElementRef);

    super(elementRef);
    this.color = 'primary';

    effect(() => {
      const isOpen = this.isOpen();
      setTimeout(() => this.visibleClass.set(isOpen), isOpen ? 0 : 500);
      (isOpen ? this.open : this.close).emit();
      if (isOpen) {
        this._elementRef.nativeElement.tabIndex = 0;
        this._elementRef.nativeElement.focus();
        this._elementRef.nativeElement.tabIndex = -1;
      }
    });
  }

  ngAfterContentInit() {
    this.buttons().forEach((button) => {
      button.color = button.color || (this.color as ThemePalette);
    });
  }

  closeFrame(event: KeyboardEvent) {
    // Prevent close on opened select dropdown close event
    const el = event.target as HTMLElement;
    if (!coerceBooleanProperty(el.ariaExpanded)) {
      this.isOpen.set(false);
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
